import { CDN_URL } from '@paladise/config/constants'

export interface IProduct {
  id: string
  name: string
  source: string
  group: string
  credit: number
  currency: string
  amount: string
  plan: string
  plan_id: number
  discount_label: string
}

export interface IProducts {
  products: IProduct[]
}

export const creditImg = [
  `${CDN_URL}/palup/consumer/battery_5_v2_1.svg`,
  `${CDN_URL}/palup/consumer/battery_1_v2_1.svg`,
  `${CDN_URL}/palup/consumer/battery_2_v2_1.svg`,
  `${CDN_URL}/palup/consumer/battery_3_v2_1.svg`,
  `${CDN_URL}/palup/consumer/battery_4_v2_1.svg`,
  `${CDN_URL}/palup/consumer/battery_customer_v2.1.svg`,
]

export interface CheckoutResponse {
  order_id: string
  stripe_subscription_id?: string
}

export const CheckoutResponseErrorState = {
  checkoutSessionProcess: 'checkoutSessionProcess',
  failed: 'failed',
} as const

export const orderState = {
  Processing: 1,
  success: 2,
  failed: 3,
} as const

export interface IContactSalesReq {
  first_name: string
  last_name: string
  email: string
  country: string
  phone: string
}

export interface ICancelFeedbackReq {
  reasons: string[]
  other_reason: string
}
